import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IReport, IUserInfo, UserInfo } from "../models";
import { RootState } from "./store";

const reportSlice = createSlice({
  name: "report",
  initialState: {
    responsible: '',
    reporter: UserInfo.empty(),
    furtherPersons: false,
    lostDevice: false,
    description: '',
    affectedPersons: '',
    affectedData: '',
    occurrence: undefined,
    recognition: undefined
  } as IReport,

  reducers: {
    setResponsible: (state, action: PayloadAction<string>) => {
        state.responsible = action.payload;
    },
    setReporter: (state, action: PayloadAction<IUserInfo>) => {
        state.reporter = action.payload;
    },
    setFurtherPersons: (state, action: PayloadAction<boolean>) => {
        state.furtherPersons = action.payload;
    },
    setLostDevice: (state, action: PayloadAction<boolean>) => {
        state.lostDevice = action.payload;
    },
    setDescription: (state, action: PayloadAction<string>) => {
        state.description = action.payload;
    },
    setAffectedPersons: (state, action: PayloadAction<string>) => {
        state.affectedPersons = action.payload;
    },
    setAffectedData: (state, action: PayloadAction<string>) => {
        state.affectedData = action.payload;
    },
    setOccurence: (state, action: PayloadAction<number|undefined>) => {
        state.occurrence = action.payload;
    },
    setRecognition: (state, action: PayloadAction<number|undefined>) => {
        state.recognition = action.payload;
    },
  },
});

export const {
    setResponsible,
    setReporter,
    setFurtherPersons,
    setLostDevice,
    setDescription,
    setAffectedPersons,
    setAffectedData,
    setOccurence,
    setRecognition,
} = reportSlice.actions;
export const selectReport = (state: RootState) => state.report;
export const reportSliceReducer = reportSlice.reducer;
